// FastaRepository.ts

import { inject, injectable } from "inversify";
import { FastaFile, PagedFastaFileList } from "@domain/schemas/BI";
import axios from "axios";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { IFastaRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";

@injectable()
export class FastaRepository implements IFastaRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  public async getListAsync(): Promise<PagedFastaFileList> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.fastaListFiles}`;
    return this._requestHandlerService.handleRequestAsync<PagedFastaFileList>(() => axios.get<PagedFastaFileList>(url));
  }

  public async uploadFileAsync(file: File, onProgress: (progress: number) => void): Promise<FastaFile> {
    const formData = new FormData();
    formData.append("file", file);

    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.fasta}`;

    return this._requestHandlerService.handleRequestAsync<FastaFile>(() =>
      axios.post<FastaFile>(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(percentCompleted);
          }
        },
      }),
    );
  }

  public async deleteFileAsync(fileName: string, folder: string | undefined): Promise<boolean> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.fasta}`;
    return this._requestHandlerService.handleRequestAsync<boolean>(() =>
      axios.delete<boolean>(url, {
        params: {
          fileName: fileName,
          folder: folder
        }
      })
    );
  }

}
